export default (value) =>
  !(value < 1000 || value > 9699 || (value >= 9485 && value <= 9498))
